/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_GoogleInputs */

const en_signin_google = /** @type {(inputs: Signin_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue with Google`)
};

/** @type {(inputs: Signin_GoogleInputs) => LocalizedString} */
const ar_signin_google = en_signin_google;

/** @type {(inputs: Signin_GoogleInputs) => LocalizedString} */
const he_signin_google = en_signin_google;

/** @type {(inputs: Signin_GoogleInputs) => LocalizedString} */
const ur_signin_google = en_signin_google;

/** @type {(inputs: Signin_GoogleInputs) => LocalizedString} */
const es_signin_google = en_signin_google;

/** @type {(inputs: Signin_GoogleInputs) => LocalizedString} */
const fr_signin_google = en_signin_google;

/** @type {(inputs: Signin_GoogleInputs) => LocalizedString} */
const de_signin_google = en_signin_google;

/** @type {(inputs: Signin_GoogleInputs) => LocalizedString} */
const pt_signin_google = en_signin_google;

/** @type {(inputs: Signin_GoogleInputs) => LocalizedString} */
const hi_signin_google = en_signin_google;

/** @type {(inputs: Signin_GoogleInputs) => LocalizedString} */
const bn_signin_google = en_signin_google;

/**
* | output |
* | --- |
* | "Continue with Google" |
*
* @param {Signin_GoogleInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_google = /** @type {((inputs?: Signin_GoogleInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_GoogleInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_google(inputs)
	if (locale === "he") return he_signin_google(inputs)
	if (locale === "ur") return ur_signin_google(inputs)
	if (locale === "es") return es_signin_google(inputs)
	if (locale === "fr") return fr_signin_google(inputs)
	if (locale === "de") return de_signin_google(inputs)
	if (locale === "pt") return pt_signin_google(inputs)
	if (locale === "hi") return hi_signin_google(inputs)
	if (locale === "bn") return bn_signin_google(inputs)
	return /** @type {LocalizedString} */ ("Continue with Google")
});